import { ToastCustom } from "@components";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { getVehicleDocumentUrl } from "../services";

export const useVehicleDocumentUrl = () => {
	const vehicleDocumentUrlMutation = useMutation({
		mutationFn: getVehicleDocumentUrl,
		onError: (error, variables) => {
			const { openUrl } = variables;
			if (error?.message) {
				const title = openUrl
					? "Erro ao abrir URL do documento"
					: "Erro ao baixar documento";
				const description = openUrl
					? "Erro ao abrir URL do documento"
					: error.message || "Erro ao baixar documento";

				toast(ToastCustom({ title, description, variant: "error" }));
			}
		},
	});

	return vehicleDocumentUrlMutation;
};
